// extracted by mini-css-extract-plugin
export default {"cta":"VJ-z","disabled":"WJ-z"};